import fernet from "fernet";
import AutoNumeric from 'autonumeric';

var secret = new fernet.Secret(process.env.REACT_APP_KEY_DECODE);

function decodeData(response_data) {
    try {
        var data = new fernet.Token({
        secret: secret,
        token: response_data,
        ttl: 0
        }).decode()
        return JSON.parse(data)
    } catch(error) {
        console.log("Loi decode", error);
    }
}

const isEmptyObject = (obj) => {
    var isEmpty = false
    obj && JSON.stringify(obj) === "{}" ? isEmpty = true : isEmpty = false
    return isEmpty
} 

const moneyFormatComma = (number, unUnit = true) => {
    var result = ""
    if(number !== "" && number !== undefined && number !== null && !isNaN(Number(number)))
    {
        result = AutoNumeric.format(Number(number), {
            digitGroupSeparator: ',',
            allowDecimalPadding	: false,
            minimumValue: '-999999999999999999999999', // đặt lại giới hạn nhỏ nhất
            maximumValue: '999999999999999999999999'
        });
    }
    var checkUnit = unUnit ? "" : " VND"
    return result + checkUnit;
}

const checkDanhXungEnglish = (danhXung, loaiHanhKhach) => {
    switch(loaiHanhKhach) {
        case 1: {
            switch(danhXung) {
                case 1: {
                    return "Mr"
                }
                case 2:
                case 3: {
                    return "Ms"
                }
                default: {
                    return ""
                }
            }
        }
        case 2: {
            switch(danhXung) {
                case 1:
                case 4: {
                    return "Mstr"
                }
                case 2:
                case 3:
                case 5: {
                    return "Miss"
                }
                default: {
                    return ""
                }
            }
        }
        case 3: {
            return "Inf"
        }
        default: {
            return ""
        }
    }
}

function formatDate(dateString) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
}


function getHangChoChange(value) {
    var hangVe = {"HotDeal":"EcoSaver","EconomySmart":"EcoSmart","EconomyFlex":"EcoFlex","EconomySaverMax":"EcoSaverMax","NON-REFUNDABLE":"NON-REFUND","REFUNDABLE":"REFUND","Economy Saver":"Eco Saver","ECONOMY SAVER":"Eco Saver","Economy Flex":"Eco Flex","ECONOMY FLEX":"Eco Flex","PREMIUM ECONOMY":"Pre Eco"}

    return hangVe[value] ? hangVe[value] : value
}

export { decodeData, isEmptyObject, moneyFormatComma, checkDanhXungEnglish, formatDate, getHangChoChange };